import { DataBean } from "../DataBean";

export class Affiliate extends DataBean {
  public async updateAffiliate(bean: any): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "com.credit.bean.CreditAffiliate_updateCreditAffiliate_com.credit.bean.CreditAffiliate",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.credit.bean.CreditAffiliate",
        },
      ]
    );
  }

  public async getAffiliateCatalogPorPropiedades(
    props: any,
    maxRows: number
  ): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "java.util.List_getCreditAffiliateCatalogPorPropiedades_java.util.Map_Number",
      [props, maxRows]
    );
  }

  public async getAffiliateInforpo(
    page: number,
    rows: number,
    props: any
  ): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "com.advantage.shared.Report_getAffiliateInforpo_Number_Number_java.util.Map",
      [page, rows, props]
    );
  }

  public async getCreditAffiliateRender(idAccount: number): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "com.credit.bean.CreditAffiliate_getCreditAffiliateRender_Number",
      [idAccount]
    );
  }

  public async getCreditAffiliateByProps(
    page: number,
    rows: number,
    props: any
  ): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "com.advantage.shared.Report_getCreditAffiliateByProps_Number_Number_java.util.Map",
      [page, rows, props]
    );
  }
}
